import { render, staticRenderFns } from "./widgetBarChart.vue?vue&type=template&id=4fee41fe"
import script from "./widgetBarChart.vue?vue&type=script&lang=js"
export * from "./widgetBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports